import type {
  LoginRequest,
  LoginResponse,
  LoginResult,
  Login2faRequest,
  AuthenticatedUserDto,
} from '@bhops/shared';
import { apiClient } from './client';

export const authApi = {
  // The API answers /auth/login with either a LoginResponse (status:'ok') or a
  // 2FA challenge (status:'2fa_required'); callers must branch on `status`.
  async login(body: LoginRequest): Promise<LoginResult> {
    const { data } = await apiClient.post<LoginResult>('/auth/login', body);
    return data;
  },
  // #12 — trade a 2FA challenge token + 6-digit TOTP code for a real session.
  async login2fa(body: Login2faRequest): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/auth/login/2fa', body);
    return data;
  },
  // docs/plan/google-sso-auth-2026-06 — Google 회사계정 SSO. GIS 가 받은 Google
  // ID 토큰을 백엔드가 검증·도메인제한·자동프로비저닝 후 우리 세션을 발급한다.
  async loginWithGoogle(idToken: string): Promise<LoginResponse> {
    const { data } = await apiClient.post<LoginResponse>('/auth/google', { idToken });
    return data;
  },
  async logout(refreshToken: string): Promise<void> {
    await apiClient.post('/auth/logout', { refreshToken });
  },
  async me(): Promise<AuthenticatedUserDto> {
    const { data } = await apiClient.get<AuthenticatedUserDto>('/auth/me');
    return data;
  },
  // windows-ux-edit (2026-06, 슬라이드2) — 사용자 자가 비밀번호 변경.
  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await apiClient.post('/auth/me/change-password', { currentPassword, newPassword });
  },
};
